'use client';

import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail } from 'lucide-react';

interface EmailFormProps {
  fileName: string;
  onEmailSubmit: (email: string, fileName: string) => void;
  onBack: () => void;
}

export function EmailForm({ fileName, onEmailSubmit, onBack }: EmailFormProps) {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    // Validar email
    if (!email || !/^\S+@\S+\.\S+$/.test(email)) {
      setError('Por favor introduce un email válido');
      return;
    }

    setError('');
    onEmailSubmit(email, fileName);
  };

  return (
    <Card className="mb-8">
      <CardHeader>
        <CardTitle className="text-xl flex items-center gap-2">
          <Mail className="h-5 w-5" />
          Un email tuyo
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Input
                type="email"
                placeholder="tu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              {error && <p className="text-sm text-destructive">{error}</p>}
            </div>

            <div className="flex items-start space-x-2">
              <input
                type="checkbox"
                id="privacy-policy"
                className="mt-1 h-4 w-4 rounded border-input text-primary focus:ring-primary"
              />
              <label htmlFor="privacy-policy" className="text-sm text-muted-foreground">
                Acepto la{' '}
                <a
                  href="/politica-privacidad"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary hover:underline"
                >
                  política de privacidad
                </a>{' '}
                de SóloSolar
              </label>
            </div>

            <div className="flex justify-end">
              <Button type="submit">
                AHORRAR YA
              </Button>
            </div>
          </form>
        </div>
      </CardContent>
    </Card>
  );
}